<template>
    <section aria-labelledby="trusted-heading" class="py-4 sm:py-8">
        <div class="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
            <div>
                <p class="text-xs font-extrabold uppercase tracking-[0.16em] text-nomad-primary/60">Selected clients</p>
                <h2 id="trusted-heading" class="mt-2 text-3xl font-extrabold tracking-tight text-nomad-primary sm:text-4xl">Trusted by.</h2>
            </div>
            <p class="max-w-sm text-sm leading-relaxed text-nomad-primary/65 sm:text-right">Digital experiences built with care for teams moving their businesses forward.</p>
        </div>

        <ul class="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" aria-label="Client logos">
            <li v-for="company in companies" :key="company.name" class="flex min-h-28 items-center justify-center rounded-2xl border border-nomad-primary/10 bg-white/60 px-4 py-5 transition hover:-translate-y-0.5 hover:border-nomad-primary/25 hover:bg-white">
                <img :src="company.src" class="max-h-16 w-full object-contain" :alt="`${company.name} logo`" loading="lazy">
            </li>
        </ul>
    </section>
</template>
<script>
export default {
    data() {
        return {
            companies: [
                // {
                //     src: '/assets/images/trusted-nomad-fitness.png'
                // },
                {
                    name: 'Flex Cleaning',
                    src: '/assets/images/logo-flexcleaning.svg'
                },
                {
                    name: 'Lanu',
                    src: '/assets/images/logo-lanu.svg'
                },
                {
                    name: 'Nomad Lyrics',
                    src: '/assets/images/logo-nomadlyrics.svg'
                },
                {
                    name: 'Midwest Rehab',
                    src: '/assets/images/logo-midwestrehabs.svg'
                },
                {
                    name: 'Blue Crescent',
                    src: '/assets/images/logo-bluecrescent.svg'
                },
                {
                    name: 'Wealth Revive',
                    src: '/assets/images/logo-wealthrevive.svg'
                }
            ]
        }
    }
}
</script>
